<template>
  <!--    <div class="g_s-item clearBoth" @click.stop="onSelectItem(item)">-->
  <div
    class="g_s-item clearBoth"
    :class="[{disabled:item.status >= 2}]"
    @click.stop="onSelectItem(item)"
  >
    <span v-if="isDantuoImg" class="g_dantuo_img"></span>
    <div
      class="s_item-label"
    >
      <span v-if="checkCopes(item)" class="number" :class="filterNumberColor(item.label)">{{ item.label }}</span>
      <span v-else :class="filterNumberColor(item.label)">{{ item.label }}</span>
    </div>
    <div v-if="isNumberRow(item)" class="label-number-row">
      <span v-for="(item, index) in isNumberRow(item)"
            :key="'numberRow' + index"
            class="number"
            :class="filterNumberColor(item)"
      >
        {{ item }}
      </span>
    </div>
    <div v-if="type !== 5 && ((current.sub_category_id==8 && playTypeRadio!=6) || current.sub_category_id!=8) && item.status >= 2" class="s_item-rate">停</div>
    <div v-else-if="type !== 5 && ((current.sub_category_id==8 && playTypeRadio!=6) || current.sub_category_id!=8)" class="s_item-rate" :class="{ change:item.ischange }">{{
        `${item.odds1 ?
          `${item.rate}/${item.odds1}` : `${item.rate}`}`
      }}
    </div>

    <div class="s_item-auto">
      <input
        v-if="(name === 'g_input_selected_item')"
        ref="input"
        class="s-inner t-block"
        v-model="value"
        :disabled="item.status >= 2"
        :class="{active: selected}"
      />
      <i v-else :class="{active: selected}" class="s-inner t-block inner-5"></i>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ObjectPath from "object-path";
import { filterNumber } from "../../../utils/objectFactory";
import { buZhongMaxSelect, LIAN_XIAO_MAX, lhCurrentTabLength, lianMaWeishu_value } from "../../../utils/lhComputed";

/***
 * name：g_input_selected_item 不可变
 * 通过 g_input_selected_item 逐级向下查找组件进行数据操作
 */
export default {
  name: "selected_item",
  props: {
    // 允许选中条件，默认允许选中
    selectRule: {
      type: Function,
      default() {
        return true;
      }
    },
    chip: String,
    current: Object,
    type: {
      type: Number,
      default: 1
      // 1 => 文字 + 比率 + 选择框
      // 2 => 数字1 || 文字 + 比率 + 选择框
      // 3 => 数字2 || 文字 + 比率 + 选择框
      // 4 =>               比率  + 选择框
      // 5 => 数字2          + 选择框
    },
    item: {
      type: Object,
      default() {
        return {
          label: "大",
          rate: 1.998,
          selected: false
        };
      }
    },
    isWeishu: Boolean,
    isSelectAll: Boolean,
    isWatch: {
      type: Boolean,
      default() {
        return true;
      }
    },
    jq: Boolean,
    yq: Boolean,
    haomaduipeng:String,
    duipengsx:String,
    duipengsx2:String,
  },
  computed: {
    ...mapState({
      curTab: state => state.home_PK10.curTab,
      headTabs: state => state.home.headTabs,
      tabs: state => state.home_PK10.tabs,
      odds: state => state.home_PK10.odds,
      lottery: state => state.home_PK10.lottery,
      order_history: state => state.home_PK10.order_history,
      longQueue: state => state.home.longQueue,
      statistics: state => state.home.statistics,
      playDantuoTotal: state => state.home.playDantuoTotal,
      lhItemTotal: state => state.home.lhItemTotal,
      playTypeRadio: state => state.home.playTypeRadio,
      shengxiaoData: state => state.home_PK10.shengxiaoData
    }),
    name() {
      if (this.isDantuoType()) {
        return 'g_input_selected_item_type_2';
      }
      return 'g_input_selected_item';
      // // 为5不可选中
      // return this.type === 5
      //   ? "g_input_selected_item_type_2"
      //   : "g_input_selected_item";
    }
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler() {
        const {id} = this.item;
        const values = this.$store.state.table.inputValues;
        const value =
          ObjectPath.get(values, `${id}`) || this.item.status === 3
            ? "封盘中"
            : "";
        this.value = this.item.status === 3 ? "" : this.value;
        this.selected = this.item.status === 3 ? false : this.selected;
        this.saveInputValie({value: {[id]: value}});
      }
    },
    'item.rate': function (val, oldval) {
      this.item.ischange = true
    },//键路
    value: {
        handler(e) {
          if (e) {
            const {id} = this.item;
            this.saveInputValie({value: {[id]: e}});
            this.selected = true;
          }
        }
    },
    isSelectAll(data) {
      if (this.isWatch) {
        if (data && Number.isInteger(parseInt(this.item.label))) {
          this.selected = true;
          this.value = this.$store.state.inputnum;
        } else {
          this.selected = false;
          this.value = "";
        }
      } else {//快乐十分
        if (!data && Number.isInteger(parseInt(this.item.label))) {
          //this.selected = true;
          this.value = this.$store.state.inputnum;
        } else {
          //this.selected = false;
          this.value = "";
        }
      }
    },
    jq(data) {
        if(data && (this.item.label=='猪' || this.item.label=='鸡' || this.item.label=='狗' || this.item.label=='马' || this.item.label=='牛' || this.item.label=='羊')) {
          this.selected = true;
          this.value = this.$store.state.inputnum;
        }else if(data==false && (this.item.label=='猪' || this.item.label=='鸡' || this.item.label=='狗' || this.item.label=='马' || this.item.label=='牛' || this.item.label=='羊')) {
          this.selected = false;
          this.value = "";
        }
    },
    yq(data) {
        if(data && (this.item.label=='猴' || this.item.label=='龙' || this.item.label=='蛇' || this.item.label=='兔' || this.item.label=='虎' || this.item.label=='鼠')) {
          this.selected = true;
          this.value = this.$store.state.inputnum;
        }else if(data==false && (this.item.label=='猴' || this.item.label=='龙' || this.item.label=='蛇' || this.item.label=='兔' || this.item.label=='虎' || this.item.label=='鼠')) {
          this.selected = false;
          this.value = "";
        }
    },
    duipengsx(data) {
      let isShengxiao = this.shengxiaoData.find(item => item.sx === data);
      if (isShengxiao) {
        let NEW_RAPID_NUMBERS = isShengxiao.m_number.split(',').map(item => Number(item));
        for(let i=0;i<NEW_RAPID_NUMBERS.length;i++){
            if(NEW_RAPID_NUMBERS[i]==this.item.label){
              this.selected = true;
              this.value = this.$store.state.inputnum;
            }
        }
      }
    },
    duipengsx2(data) {
      let isShengxiao = this.shengxiaoData.find(item => item.sx === data);
      if (isShengxiao) {
        let NEW_RAPID_NUMBERS = isShengxiao.m_number.split(',').map(item => Number(item));
        for(let i=0;i<NEW_RAPID_NUMBERS.length;i++){
            if(NEW_RAPID_NUMBERS[i]==this.item.label){
              this.selected = true;
              this.value = this.$store.state.inputnum;
            }
        }
      }
    }
  },
  data() {
    return {
      selected: false,
      value: "",
      // 胆拖img
      isDantuoImg: false,
    };
  },
  methods: {
    ...mapActions("table", {
      saveInputValie: "saveInputValie"
    }),
    ...mapActions({
      onSetPlayDantuoTotal: 'home/onSetPlayDantuoTotal',
      onSetLhItemTotal: 'home/onSetLhItemTotal'
    }),
    // 涉及有胆拖的玩法
    isDantuoType() {
      const currentValue = ObjectPath.get(this.current, 'value');
      if (currentValue === 6 || currentValue === 7 || currentValue === 8 || currentValue === 9 || currentValue === 11 || currentValue === 12 || currentValue === 13) {
        return true;
      }
      return false;
    },
    // 判断是否是胆拖
    isDantuoClass(newPlayDantuoTotal, class3) {
      let DEFUALT_DANTUO_IMG = false;
      // 当有胆拖的玩法，并且类型为胆拖
      if (this.isDantuoType() && this.playTypeRadio == 2) {
        if (Object.keys(newPlayDantuoTotal).some(dantuo => dantuo === class3)) {
          DEFUALT_DANTUO_IMG = true;
        }
      }
      this.isDantuoImg = DEFUALT_DANTUO_IMG;
    },
    onNumberRowFindItem(class3) {
      const findItem = this.shengxiaoData.find(shengxiaoItem => shengxiaoItem.sx === class3);
      if (findItem) {
        if(this.item.class2=="六肖"&&(findItem.m_number=="01,13,25,37,49"||findItem.m_number=="01,13,25,37")){
          let newN = "01,13,25,37";
          return newN.split(',');
        }else if(findItem.m_number=="01,13,25,37"){
          let newN = "01,13,25,37,49";
          return newN.split(',');
        }else{
          return findItem.m_number.split(',');
        }
      }
      return '0';
    },
    // 检查是否展示number 列
    isNumberRow(item) {
      const currentValue = ObjectPath.get(this.current, 'value');
      const {class2, class3} = item;
      // 半波
      if (currentValue === 14) {
        const DEFAULT_VALUE = {
          '红大': '29,30,34,35,40,45,46',
          '红小': '01,02,07,08,12,13,18,19,23,24',
          '红单': '01,07,13,19,23,29,35,45',
          '红双': '02,08,12,18,24,30,34,40,46',
          '蓝大': '25,26,31,36,37,41,42,47,48',
          '蓝小': '03,04,09,10,14,15,20',
          '蓝单': '03,09,15,25,31,37,41,47',
          '蓝双': '04,10,14,20,26,36,42,48',
          '绿大': '27,28,32,33,38,39,43,44',
          '绿小': '05,06,11,16,17,21,22',
          '绿单': '05,11,17,21,27,33,39,43',
          '绿双': '06,16,22,28,32,38,44',
        };
        return DEFAULT_VALUE[class3].split(',');
      }
      // 五行
      if (currentValue === 15) {
        const DEFAULT_VALUE = {
          '金': '01,06,11,16,21,26,31,36,41,46',
          '木': '02,07,12,17,22,27,32,37,42,47',
          '水': '03,08,13,18,23,28,33,38,43,48',
          '火': '04,09,14,19,24,29,34,39,44,49',
          '土': '05,10,15,20,25,30,35,40,45',
        };
        return DEFAULT_VALUE[class3].split(',');
      }
      // 特肖
      if (currentValue === 4) {
        if (this.shengxiaoData && class2 === '特肖') {
          return this.onNumberRowFindItem(class3);
        }
      }
      // 一肖尾数
      if (currentValue === 5) {
        if (this.shengxiaoData && (class2 === '一肖中' || class2 === '一肖不中')) {
          return this.onNumberRowFindItem(class3);
        }
      }
      // 合肖
      if (currentValue === 11 || currentValue === 6) {
        if (this.shengxiaoData) {
          return this.onNumberRowFindItem(class3);
        }
      }
      if (currentValue === 8 && (this.playTypeRadio == 3 || this.playTypeRadio == 5) &&
        !this.isWeishu &&
        (class2 === '二全中' || class2 === '二中特' || class2 === '二中特X' || class2 === '特串')) {
        if (this.shengxiaoData) {
          return this.onNumberRowFindItem(class3);
        }
      }
      // 连尾
      if (currentValue === 7 ||
        (currentValue === 5 && (class2 === '尾数中' || class2 === '尾数不中')) ||
        (currentValue === 8 && this.playTypeRadio == 4) ||
        (currentValue === 8 && this.playTypeRadio == 5 && this.isWeishu && (class2 === '二全中' || class2 === '二中特' || class2 === '二中特X' || class2 === '特串'))
      ) {
        return lianMaWeishu_value[class3] && lianMaWeishu_value[class3].split(',');
      }
      return false;
    },

    // 校验六合 特码ab 与特码
    checkCopes(item) {
      const flag = Number(item.class3) > 0 && Number(item.class3) < 50;
      return flag;
    },
    // 过滤当前number的背景图片颜色
    filterNumberColor(checkNumber) {
      const isFilterNumber = filterNumber(checkNumber);
      if (isFilterNumber) {
        return isFilterNumber;
      }
      if (checkNumber && isNaN(Number(checkNumber))) {
        if (checkNumber.indexOf('红') > -1) return 'banbo-red';
        if (checkNumber.indexOf('绿') > -1) return 'banbo-green';
        if (checkNumber.indexOf('蓝') > -1) return 'banbo-blue';
        return 'banbo-yellow';
      }
      return '';
    },
    showLabel(label) {
      if (this.type === 1) {
      } else {
        if (this.checkNumber(label)) label = "";
      }
      return label;
    },
    onSelectItem(item) {
      // 在点击时需要做六合的特定玩法校验
      let newLhItemTotal = this.lhItemTotal;
      if (
        (this.current.sub_category_id === 6 && this.current.label === '连肖') ||
        (this.current.sub_category_id === 7 && this.current.label === '连尾') ||
        (this.current.sub_category_id === 8 && this.current.label === '连码') ||
        (this.current.sub_category_id === 9 && this.current.label === '自选不中') ||
        (this.current.sub_category_id === 11 && this.current.label === '合肖') ||
        (this.current.sub_category_id === 12 && this.current.label === '特平中') ||
        (this.current.sub_category_id === 13 && this.current.label === '中一')
      ) {
        // 如果未选选中的item，追加到vuex
        if (!this.selected) {
          item._haomaduipeng = this.haomaduipeng;
          newLhItemTotal = {
            ...newLhItemTotal,
            [item.class3]: item
          };
        }
        // 删除选中状态
        if (this.selected) {
          ObjectPath.del(newLhItemTotal, item.class3);
        }
        // 取最新的校验
        let lhItemTotalLength = Object.keys(newLhItemTotal).length;
        const firstOrderClass1 = ObjectPath.get(item, `class1`);
        const firstOrderClass2 = ObjectPath.get(item, `class2`);
        if (firstOrderClass1 === '连肖' && lhItemTotalLength > LIAN_XIAO_MAX) {
          return this.$Message.error(`最多选择${LIAN_XIAO_MAX}个号码`);
        }
        if (firstOrderClass1 === '连尾' && lhItemTotalLength > 8) {
          return this.$Message.error(`最多选择8个号码`);
        }
        if (firstOrderClass1 === '自选不中') {
          const maxSelect = buZhongMaxSelect(firstOrderClass2);
          if (maxSelect && lhItemTotalLength > maxSelect) {
            return this.$Message.error(`最多选择${maxSelect}个号码`);
          }
        }
        if ((firstOrderClass1 === '中一' || firstOrderClass1 === '特平中') && lhItemTotalLength > 20) {
          return this.$Message.error(`最多选择20个号码`);
        }
        if (lhItemTotalLength > 2 && (this.playTypeRadio == 3 || this.playTypeRadio == 4 || this.playTypeRadio == 5)) return this.$Message.error(`最多选择2个号码`);
        // 连码最多10个号码
        if (
          ((firstOrderClass2 === '三全中' || firstOrderClass2 === '三中二' || firstOrderClass2 === '三中二X') && (this.playTypeRadio == 1 || this.playTypeRadio == 2) && lhItemTotalLength > 10)
        ) {
          return this.$Message.error(`最多选择10个号码`);
        }
      }
      // 正常流程
      if (item.status >= 2) return;
      if (!this.selectRule(this.type, !this.selected)) return;
      this.selected = !this.selected;
      if (
        this.name === "g_input_selected_item" ||
        this.name === "g_input_selected_item_type_2"
      ) {
        this.value = this.selected ? this.chip : "";
      }
      this.$refs.input && this.$refs.input.focus();
      // 最新的total
      let newPlayDantuoTotal = this.playDantuoTotal;
      // 胆拖的长度
      const firstOddItemClass2 = ObjectPath.get(item, 'class2');
      let length = lhCurrentTabLength(firstOddItemClass2);
      let newLength = Object.keys(newPlayDantuoTotal).length;
      // 判断当前点击的胆拖
      if (this.selected) {
        this.value = this.$store.state.inputnum;
        // 把胆拖存起来
        if (newLength < length - 1) {
          newPlayDantuoTotal = {
            ...newPlayDantuoTotal,
            [item.class3]: item
          }
        }
      }
      // 如果是取消选中, 就删除掉存储的class3的胆拖
      if (!this.selected) {
        ObjectPath.del(newPlayDantuoTotal, item.class3);
      }
      this.onSetPlayDantuoTotal(newPlayDantuoTotal);
      this.onSetLhItemTotal(newLhItemTotal);
      this.isDantuoClass(newPlayDantuoTotal, item.class3);
    },
    checkNumber(str) {
      const n = Number(str);
      return typeof n === "number" && n.toString() !== "NaN";
    }
  },
  created() {
    if (this.isSelectAll && Number.isInteger(parseInt(this.item.label))) {
      this.selected = true;
    }
  },
  destroyed() {
    this.onSetPlayDantuoTotal({});
    this.onSetLhItemTotal({});
  },
};
</script>

<style scoped lang="stylus">
.theme-1 .s-inner{
  background:#ffa9331a
}
.theme-2 .s-inner{
  background:#e8f9eb
}
.theme-3 .s-inner{
  background:#a571d112
}
// 修改
.s-inner {
  text-align: center;
  outline: none;
}

.number-type-2 {
  .number1 {
    background-image: url('');
  }
}

$border_d-color = #e6e6e6;

.g_s-item {
  position: relative
  cursor: pointer;
  height: 30px;
  display: flex;
  font-weight: bold;
  line-height: 30px;
  border-bottom: 1px solid $border_d-color;

  &:hover {
    background-color: #eff1ea;
  }

  &.disabled {
    background-color: #efefef;
    cursor: no-drop;
  }

  div {
    height: 100%;
    padding: 0 5px;
    text-align: center;
    box-sizing: border-box;
  }

  > div + div {
    border-left: 1px solid $border_d-color;
  }

  .s_item-label {
    width: 160px;
    display: flex;
    font-weight: 500;
    align-items: center;
    justify-content: center;
    padding: 3px;
  }

  .number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 25px;
    background-size: contain;
    font-size: 13px;
    font-weight: bold;
    padding-bottom: 2px;
  }

  .number-blue {
    color:#0b0c0c;
    background: url('../../../assets/back_blue.png') no-repeat center center;
  }

  .number-green {
    color:#0b0c0c;
    background: url('../../../assets/back_green.png') no-repeat center center;
  }

  .number-red {
    color:#0b0c0c;
    background: url('../../../assets/back_red.png') no-repeat center center;
  }

  .s_item-rate, .s_item-auto {
    width: 200px;
    color: #FF0000;
    font-weight: 500;
  }

  .change {
    background: #fffa00;
  }

  .s_item-auto {
    display: flex;
    align-items: center;
    justify-content: center;

    .s-inner {
      width: 100%;
      height: 20px;
      border: 1px solid #bfbfbf;
      display: inline-block;
      border-radius: 2px;
    }

    .s-inner[disabled] {
      background: $border_d-color;
      color: rgb(84, 84, 84);
    }

    .inner-5 {
      height: 15px;
      width: 15px;
    }
  }

  .banbo-red,
  .banbo-green,
  .banbo-yellow,
  .banbo-blue {
    padding: 0 5px;
    line-height 24px;
    border-radius: 4px;
    color: rgba(255, 254, 254, 1);
  }

  .banbo-red {
    background: rgba(255, 77, 85, 1);
  }

  .banbo-green {
    background: rgba(46, 209, 100, 1);
  }

  .banbo-blue {
    background: rgba(69, 143, 255, 1);
  }

  .banbo-yellow {
    background: rgba(255, 174, 19, 1);
  }

  // 号码部分样式

  .label-number-row {
    display: flex;
    justify-content center;
    width: 400px;

    .number {
      width: 25px;
    }
  }
}

// 胆拖图片
.g_dantuo_img {
  width: 22px;
  height: 27px;
  position: absolute;
  right: 0;
  background: url('../../../assets/LM_D.gif') no-repeat center center;
  background-position-x: 98%;
}
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-item/g_switch-item4.vue